module.exports = __webpack_public_path__ + "img/screenshot_example_02.a332fdc7.png";